import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=7ac0b58f"
import script from "./StatusBar.vue?vue&type=script&lang=ts"
export * from "./StatusBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports